import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function Updatevehiclemaintenance() {

    const [dueDateType, setDueDateType] = useState('date');


    const handleDropdownChange = (event) => {
        setDueDateType(event.target.value);
    };

    return (
        <div className="createvehiclemaintain-container my-4">
            <div className="col-md-12">
                <div className="special-header panel-white-all">
                    <h4 className="page-title">Update Vehicle Maintenance</h4>
                </div>

                <form>
                    <div className="row update-vehicle-maintain">
                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="busno" className="form-label">Bus Code <span className="text-danger">*</span></label>
                            <select id="busno" className="form-control createmaintain-form-select" >
                                <option>Select</option>
                                <option>MH21WE9021</option>
                                <option>MH02WE0002</option>
                                <option>MH03BR8934</option>
                            </select>
                        </div>

                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="tasktype" className="form-label"> Type of Task <span className="text-danger">*</span> </label>
                            <select id="tasktype" className="form-control createmaintain-form-select" required>
                                <option>Select</option>
                                <option>Instant</option>
                                <option>Scheduled</option>
                            </select>
                        </div>

                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="maintaintask" className="form-label"> Maintenance Task<span className="text-danger">*</span>  </label>
                            <input type="text" id="maintaintask" className="form-control createfuel-form-control" required />
                        </div>

                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="schedule" className="form-label"> Schedule Duration(H) <span className="text-danger">*</span> </label>
                            <select id="schedule" className="form-control createmaintain-form-select" requireduu>
                                <option>Select</option>
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                            </select>
                        </div>


                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="date" className="form-label">Start Date <span className="text-danger">*</span></label>
                            <input type="date" id="date" className="form-control createfuel-form-control" />
                        </div>

                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="dueDateType" className="form-label"> Next Due Date / Mileage <span className="text-danger">*</span></label>
                            <select id="dueDateType" className="form-control createfuel-form-select"
                                value={dueDateType} onChange={handleDropdownChange} >

                                <option value="date">Date</option>
                                <option value="mileage">Mileage</option>
                            </select>
                        </div>


                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="amount" className="form-label">Vehicle Maintenance Cost <span className="text-danger">*</span> </label>
                            <input type="text" id="amount" className="form-control createfuel-form-control" placeholder="Enter amount" />
                        </div>



                        {dueDateType === 'date' && (
                            <div className="col-lg-6 col-md-12 mb-3">
                                <label htmlFor="nextDate" className="form-label"> Vehicle Maintenance Next Due Date </label>
                                <input type="date" id="nextDate" className="form-control createfuel-form-control" />
                            </div>
                        )}

                        {dueDateType === 'mileage' && (
                            <div className="col-lg-6 col-md-12 mb-3">
                                <label htmlFor="dueMileage" className="form-label"> Due Mileage <span className="text-danger">*</span></label>
                                <input type="text" id="dueMileage" className="form-control createfuel-form-control" placeholder="Enter due mileage" />
                            </div>
                        )}

                        <div class="offroad-form-check">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                            <label class="form-check-label" for="flexCheckDefault">
                                Off-Road
                            </label>
                        </div>


                        <div className="col-lg-12 col-md-12 mt-3 d-flex justify-content-end">
                            <Link to="/" type="submit" className="btn custom-btn"> Update </Link>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}